import type { Collection } from '../../../collection'
import type * as ecModels from '../../../models'
import type * as plugin from '../../plugin'

import type { Config } from './config'
import { Plugin } from './plugin'

/**
 * {@link plugin.Plugin.Factory} for this {@link Plugin}
 * ({@link plugin.Plugin.Id.Standard.DataOperation})
 */
export class Factory<TTypeParams extends ecModels.TypeParams>
  implements
    plugin.Plugin.Factory<
      TTypeParams,
      plugin.Plugin.Id.Standard.DataOperation,
      Plugin<TTypeParams>
    >
{
  public readonly id = Plugin.Id.Standard.DataOperation
  constructor(private readonly _config: Config.Options<TTypeParams> = {}) {}

  public produceFor(collection: Collection<TTypeParams>): Plugin<TTypeParams> {
    return new Plugin<TTypeParams>({ collection, config: this._config })
  }
}
